'use client';

import React, { useState, useEffect } from 'react';

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    
    // If not accepted yet, show the banner
    if (!cookiesAccepted) {
      setIsVisible(true);
    }
  }, []);

  function handleAccept() {
    // Save acceptance to localStorage
    localStorage.setItem('cookiesAccepted', 'true');
    setIsVisible(false);
  }

  function handleDecline() {
    // Handle decline - only essential cookies are used
    localStorage.setItem('cookiesAccepted', 'false');
    setIsVisible(false);
  }

  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>
          Utilitzem cookies per millorar la teva experiència de navegació i 
          proporcionar-te contingut més rellevant. En fer clic a "Acceptar", 
          consents l'ús de cookies tal com es descriu a la nostra política de cookies.
        </p>
        <div className="cookie-buttons">
          <button 
            className="cookie-button accept"
            onClick={handleAccept}
          >
            Acceptar
          </button>
          <button 
            className="cookie-button decline"
            onClick={handleDecline}
          >
            Només essencials
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner; 